var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"map"}}),_c('Rehearsal'),_c('WaterQualityDetail',{attrs:{"visible":_vm.visible,"detail":_vm.detail,"params":_vm.params},on:{"cancel":function($event){_vm.visible = false;
  _vm.detail = {};
  _vm.params = {};}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }